import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { Y42AgGridModule } from '@y42/ag-grid';
import { LogsAgGridComponent } from './logs-ag-grid.component';

@NgModule({
  declarations: [LogsAgGridComponent],
  imports: [CommonModule, MatProgressBarModule, Y42AgGridModule],
  exports: [LogsAgGridComponent],
})
export class LogsAgGridModule {}
